import { render, staticRenderFns } from "./LevelAssetMarker.vue?vue&type=template&id=67c3d70b&"
import script from "./LevelAssetMarker.vue?vue&type=script&lang=js&"
export * from "./LevelAssetMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports